// assets
import { IconPuzzle, IconEdit, IconChartHistogram, IconFiles } from '@tabler/icons';
// constant
const icons = {
  IconPuzzle,
  IconEdit,
  IconChartHistogram,
  IconFiles
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const exams = {
  id: 'exams',
  title: 'Examination',
  type: 'group',
  children: [
    {
      id: 'questions',
      title: 'Questions',
      type: 'item',
      url: '/exams/questions',
      icon: icons.IconPuzzle,
      breadcrumbs: false
    },
    {
      id: 'questionsheets',
      title: 'Question Sheets',
      type: 'item',
      url: '/exams/questionsheets',
      icon: icons.IconFiles,
      breadcrumbs: false
    },
    {
      id: 'tests',
      title: 'Tests',
      type: 'item',
      url: '/exams/tests',
      icon: icons.IconEdit,
      breadcrumbs: false
    },
    {
      id: 'evaluation',
      title: 'Evaluation',
      type: 'item',
      url: '/exams/evaluation',
      icon: icons.IconChartHistogram,
      breadcrumbs: false
    }
  ]
};

const admin_exams = {
  id: 'exams',
  title: 'Examination',
  type: 'group',
  children: [
    {
      id: 'questions',
      title: 'Questions',
      type: 'item',
      url: '/exams/questions',
      icon: icons.IconPuzzle,
      breadcrumbs: false
    },
    {
      id: 'questionsheets',
      title: 'Question Sheets',
      type: 'item',
      url: '/exams/questionsheets',
      icon: icons.IconFiles,
      breadcrumbs: false
    }
  ]
};

export { exams, admin_exams }